/**
 * External dependencies
 */
import {
	withBlockStyles,
	withSetAttributeHook,
	withTabbedInspector,
	withUniqueClass,
	withClickOpenInspector,
} from '~cartzillagb/higher-order'

import {
	getAttrName,
	createButtonAttributeNames,
	createResponsiveAttributeNames,
} from '~cartzillagb/util'

import {
	BlockContainer,
	AdvancedRangeControl,
	PanelAdvancedSettings,
	PanelSpacingBody,
	ResponsiveControl,
	ButtonControlsHelper,
	ButtonEditHelper,
} from '~cartzillagb/components'

import { i18n } from 'cartzillagb'
import classnames from 'classnames'
import createStyles from './style'
import { showOptions } from './util'
import $ from 'jquery'

import './common'

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'
import {
	Fragment,
	useRef,
	useEffect
} from '@wordpress/element'
import { 
	addFilter,
	applyFilters
} from '@wordpress/hooks'
import {
	InnerBlocks,
	RichText
} from '@wordpress/block-editor'

import {
	PanelBody,
	ToggleControl,
	RangeControl
} from '@wordpress/components'

import { 
	withDispatch
} from '@wordpress/data'

import { compose } from '@wordpress/compose'

addFilter( 'cartzillagb.products-carousel.edit.inspector.style.before', 'cartzillagb/products-carousel', ( output, props ) => {
	const {
		attributes,
		setAttributes
	} = props
	const {
		enableContainer,

		// Title.
		showTitle = true,

		// Button.
		showHeaderButton = false,
		showFooterButton = false,

		// Carousel
		dots,
		arrows,
		infinite,
		autoplay,
		autoplaySpeed
	} = attributes

	const show = showOptions( props )

	return (
		<Fragment>
			<PanelBody title={ __( "General Settings", i18n ) } initialOpen={ true }>
				<ToggleControl
					label={ __( 'Enable Container', i18n ) }
					checked={ enableContainer }
					onChange={ enableContainer => setAttributes( { enableContainer } ) }
				/>
				<ToggleControl
					label={ __( 'Show Title', i18n ) }
					checked={ showTitle }
					onChange={ showTitle => setAttributes( { showTitle } ) }
				/>
			</PanelBody>
			<PanelBody title={ __( "Carousel Options", i18n ) } initialOpen={ true }>
				<ResponsiveControl
					attrNameTemplate="slidesToShow%s"
					setAttributes={ setAttributes }
					blockAttributes={ attributes }
					screens={ [ 'desktop', 'laptop', 'tablet', 'mobile' ] }
				>
					<AdvancedRangeControl
						label={ __( 'Slides To Show', i18n ) }
						min={ 1 }
						max={ applyFilters( 'cartzillagb.products-carousel.edit.inspector.max.slidesToShow', 8 ) }

					/>
				</ResponsiveControl>
				<ResponsiveControl
					attrNameTemplate="slidesToScroll%s"
					setAttributes={ setAttributes }
					blockAttributes={ attributes }
					screens={ [ 'desktop', 'laptop', 'tablet', 'mobile' ] }
				>
					<AdvancedRangeControl
						label={ __( 'Slides To Scroll', i18n ) }
						min={ 1 }
						max={ applyFilters( 'cartzillagb.products-carousel.edit.inspector.max.slidesToScroll', 8 ) }

					/>
				</ResponsiveControl>
				<ToggleControl
					label={ __( 'Enable Dots', i18n ) }
					checked={ dots }
					onChange={ dots => setAttributes( { dots } ) }
				/>
				<ToggleControl
					label={ __( 'Enable Arrow', i18n ) }
					checked={ arrows }
					onChange={ arrows => setAttributes( { arrows } ) }
				/>
				<ToggleControl
					label={ __( 'Enable Infinite Scroll', i18n ) }
					checked={ infinite }
					onChange={ infinite => setAttributes( { infinite } ) }
				/>
				<ToggleControl
					label={ __( 'Enable Autoplay?', i18n ) }
					checked={ autoplay }
					onChange={ autoplay => setAttributes( { autoplay } ) }
				/>
				{ autoplay && 
					<RangeControl
						label={ __( 'Autoplay Speed' ) }
						value={ autoplaySpeed }
						onChange={ autoplaySpeed => setAttributes( { autoplaySpeed } ) }
						min={ 1000 }
						step={ 1000 }
						max={ applyFilters( 'cartzillagb.products-carousel.edit.inspector.max.speed', 7000 ) }
					/>
				}
			</PanelBody>
			<PanelAdvancedSettings
				title={ __( 'Header Button', i18n ) }
				id="header-button"
				checked={ showHeaderButton }
				onChange={ showHeaderButton => setAttributes( { showHeaderButton } ) }
				toggleOnSetAttributes={ [
					...createButtonAttributeNames( 'headerButton%s' ),
					...createResponsiveAttributeNames( 'headerButton%sAlign' ),
				] }
				toggleAttributeName="showHeaderButton"
			>
				<ButtonControlsHelper
					attrNameTemplate="headerButton%s"
					setAttributes={ setAttributes }
					blockAttributes={ attributes }
				/>
			</PanelAdvancedSettings>
			<PanelAdvancedSettings
				title={ __( 'Footer Button', i18n ) }
				id="footer-button"
				checked={ showFooterButton }
				onChange={ showFooterButton => setAttributes( { showFooterButton } ) }
				toggleOnSetAttributes={ [
					...createButtonAttributeNames( 'footerButton%s' ),
					...createResponsiveAttributeNames( 'footerButton%sAlign' ),
				] }
				toggleAttributeName="showFooterButton"
			>
				<ButtonControlsHelper
					attrNameTemplate="footerButton%s"
					setAttributes={ setAttributes }
					blockAttributes={ attributes }
				/>
			</PanelAdvancedSettings>
			{ ( show.titleSpacing || show.headerSpacing || show.footerSpacing ) &&
				<PanelSpacingBody
					initialOpen={ false }
					blockProps={ props }
				>
					{ ( show.titleSpacing || show.headerSpacing ) &&
						<ResponsiveControl
							attrNameTemplate="header%sBottomMargin"
							setAttributes={ setAttributes }
							blockAttributes={ attributes }
						>
							<AdvancedRangeControl
								label={ show.headerSpacing ? __( 'Header', i18n ) : __( 'Title', i18n ) }
								min={ -50 }
								max={ 100 }
								allowReset={ true }
								className="czgb--help-tip-spacing-header"
							/>
						</ResponsiveControl>
					}
					{ show.footerSpacing &&
						<ResponsiveControl
							attrNameTemplate="footer%sTopMargin"
							setAttributes={ setAttributes }
							blockAttributes={ attributes }
						>
							<AdvancedRangeControl
								label={ __( 'Footer', i18n ) }
								min={ -50 }
								max={ 100 }
								allowReset={ true }
								className="czgb--help-tip-spacing-footer"
							/>
						</ResponsiveControl>
					}
				</PanelSpacingBody>
			}
		</Fragment>
	)
} )

const edit = props => {
	const {
		className,
		attributes,
		setAttributes,
		updateColumns,
		clientId,
	} = props
 
	const {
		blockId,
		enableContainer,

		// Title.
		showTitle = true,
		title = '',

		// Button.
		showHeaderButton = false,
		showFooterButton = true,

		// Carousel
		slidesToShow,
		slidesToShowLaptop,
		slidesToShowTablet,
		slidesToShowMobile,
		slidesToScroll,
		slidesToScrollLaptop,
		slidesToScrollTablet,
		slidesToScrollMobile,
		dots,
		arrows,
		infinite,
		autoplay,
		autoplaySpeed
	} = attributes

	const slickEl = useRef( blockId || clientId )

	const getAttrValue = ( attrName, defaultValue = '' ) => {
		const value = attributes[ getAttrName( attrName ) ]
		return value === 0 ? value : ( value || defaultValue )
	}

	useEffect( () => {
		updateColumns( slidesToShow )
	}, [
		slidesToShow,
	] )

	useEffect( () => {
		if ( slickEl.current && $( slickEl.current ).find( '.products' ).length && $( slickEl.current ).closest( '.wp-block-czgb-products-carousel' ).data( 'slick-attributes' ) ) {
			if( $( slickEl.current ).find( '.products.slick-initialized' ).length ) {
				let slickAttributes = JSON.parse( $( slickEl.current ).closest( '.wp-block-czgb-products-carousel' ).attr( 'data-slick-attributes' ) )
				const slickId = $( slickEl.current ).closest( '.wp-block-czgb-products-carousel' ).attr( 'id' )

				if( slickAttributes && slickAttributes.customArrows && ! slickAttributes.appendArrows ) {
					slickAttributes = { ...slickAttributes, appendArrows: `#${slickId} ${slickAttributes.customArrows}` }
				}

				$( slickEl.current ).find( '.products' ).attr( 'data-slick', JSON.stringify( {...slickAttributes} ) )
				$( slickEl.current ).find( '.products' ).slick( 'setOption', {
					'slidesToShow': attributes.slidesToShow,
					'slidesToScroll': attributes.slidesToScroll,
					'responsive': [
						{
							breakpoint: 1199.98,
							settings: {
								slidesToShow: slidesToShowLaptop,
								slidesToScroll: slidesToScrollLaptop,
							}
						},
						{
							breakpoint: 991.98,
							settings: {
								slidesToShow: slidesToShowTablet,
								slidesToScroll: slidesToScrollTablet,
							}
						},
						{
							breakpoint: 575.98,
							settings: {
								slidesToShow: slidesToShowMobile,
								slidesToScroll: slidesToScrollMobile,
							}
						}
					],
				}, true )
				$( slickEl.current ).find( '.products' ).slick( 'updateDots' )
				$( slickEl.current ).find( '.products' ).slick( 'updateArrows' )
				$( slickEl.current ).find( '.products' ).slick( 'refresh' )
			}
		}
	}, [
		slidesToShow,
		slidesToShowLaptop,
		slidesToShowTablet,
		slidesToShowMobile,
		slidesToScroll,
		slidesToScrollLaptop,
		slidesToScrollTablet,
		slidesToScrollMobile,
	] )

	useEffect( () => {
		if ( slickEl.current && $( slickEl.current ).find( '.products' ).length && $( slickEl.current ).closest( '.wp-block-czgb-products-carousel' ).data( 'slick-attributes' ) ) {
			if( $( slickEl.current ).find( '.products.slick-initialized' ).length ) {
				let slickAttributes = JSON.parse( $( slickEl.current ).closest( '.wp-block-czgb-products-carousel' ).attr( 'data-slick-attributes' ) )
				const slickId = $( slickEl.current ).closest( '.wp-block-czgb-products-carousel' ).attr( 'id' )

				if( slickAttributes && slickAttributes.customArrows && ! slickAttributes.appendArrows ) {
					slickAttributes = { ...slickAttributes, appendArrows: `#${slickId} ${slickAttributes.customArrows}` }
				}

				$( slickEl.current ).find( '.products' ).attr( 'data-slick', JSON.stringify( {...slickAttributes} ) )
				$( slickEl.current ).find( '.products' ).slick( 'setOption', {
					'dots': attributes.dots,
				}, true )
				$( slickEl.current ).find( '.products' ).slick( 'updateDots' )
				$( slickEl.current ).find( '.products' ).slick( 'refresh' )
			}
		}
	}, [
		dots
	] )

	useEffect( () => {
		if ( slickEl.current && $( slickEl.current ).find( '.products' ).length && $( slickEl.current ).closest( '.wp-block-czgb-products-carousel' ).data( 'slick-attributes' ) ) {
			if( $( slickEl.current ).find( '.products.slick-initialized' ).length ) {
				let slickAttributes = JSON.parse( $( slickEl.current ).closest( '.wp-block-czgb-products-carousel' ).attr( 'data-slick-attributes' ) )
				const slickId = $( slickEl.current ).closest( '.wp-block-czgb-products-carousel' ).attr( 'id' )

				if( slickAttributes && slickAttributes.customArrows && ! slickAttributes.appendArrows ) {
					slickAttributes = { ...slickAttributes, appendArrows: `#${slickId} ${slickAttributes.customArrows}` }
				}

				$( slickEl.current ).find( '.products' ).attr( 'data-slick', JSON.stringify( {...slickAttributes} ) )
				$( slickEl.current ).find( '.products' ).slick( 'setOption', {
					'arrows': attributes.arrows,
				}, true )
				$( slickEl.current ).find( '.products' ).slick( 'updateArrows' )
				$( slickEl.current ).find( '.products' ).slick( 'refresh' )
			}
		}
	}, [
		arrows
	] )

	useEffect( () => {
		if ( slickEl.current && $( slickEl.current ).find( '.products' ).length && $( slickEl.current ).closest( '.wp-block-czgb-products-carousel' ).data( 'slick-attributes' ) ) {
			if( $( slickEl.current ).find( '.products.slick-initialized' ).length ) {
				let slickAttributes = JSON.parse( $( slickEl.current ).closest( '.wp-block-czgb-products-carousel' ).attr( 'data-slick-attributes' ) )
				const slickId = $( slickEl.current ).closest( '.wp-block-czgb-products-carousel' ).attr( 'id' )

				if( slickAttributes && slickAttributes.customArrows && ! slickAttributes.appendArrows ) {
					slickAttributes = { ...slickAttributes, appendArrows: `#${slickId} ${slickAttributes.customArrows}` }
				}

				$( slickEl.current ).find( '.products' ).attr( 'data-slick', JSON.stringify( {...slickAttributes} ) )
				$( slickEl.current ).find( '.products' ).slick( 'setOption', {
					'autoplay': attributes.autoplay,
				}, true )
				$( slickEl.current ).find( '.products' ).slick( 'refresh' )
			}
		}
	}, [
		autoplay
	] )


	useEffect( () => {
		if ( slickEl.current && $( slickEl.current ).find( '.products' ).length && $( slickEl.current ).closest( '.wp-block-czgb-products-carousel' ).data( 'slick-attributes' ) ) {
			if( $( slickEl.current ).find( '.products.slick-initialized' ).length ) {
				let slickAttributes = JSON.parse( $( slickEl.current ).closest( '.wp-block-czgb-products-carousel' ).attr( 'data-slick-attributes' ) )
				const slickId = $( slickEl.current ).closest( '.wp-block-czgb-products-carousel' ).attr( 'id' )

				if( slickAttributes && slickAttributes.customArrows && ! slickAttributes.appendArrows ) {
					slickAttributes = { ...slickAttributes, appendArrows: `#${slickId} ${slickAttributes.customArrows}` }
				}

				$( slickEl.current ).find( '.products' ).attr( 'data-slick', JSON.stringify( {...slickAttributes} ) )
				$( slickEl.current ).find( '.products' ).slick( 'setOption', {
					'autoplaySpeed': attributes.autoplaySpeed,
				}, true )
				$( slickEl.current ).find( '.products' ).slick( 'refresh' )
			}
		}
	}, [
		autoplaySpeed
	] )

	useEffect( () => {
		if ( slickEl.current && $( slickEl.current ).find( '.products' ).length && $( slickEl.current ).closest( '.wp-block-czgb-products-carousel' ).data( 'slick-attributes' ) ) {
			if( $( slickEl.current ).find( '.products.slick-initialized' ).length ) {
				let slickAttributes = JSON.parse( $( slickEl.current ).closest( '.wp-block-czgb-products-carousel' ).attr( 'data-slick-attributes' ) )
				const slickId = $( slickEl.current ).closest( '.wp-block-czgb-products-carousel' ).attr( 'id' )

				if( slickAttributes && slickAttributes.customArrows && ! slickAttributes.appendArrows ) {
					slickAttributes = { ...slickAttributes, appendArrows: `#${slickId} ${slickAttributes.customArrows}` }
				}

				$( slickEl.current ).find( '.products' ).attr( 'data-slick', JSON.stringify( {...slickAttributes} ) )
				$( slickEl.current ).find( '.products' ).slick( 'setOption', {
					'infinite': attributes.infinite,
				}, true )
				$( slickEl.current ).find( '.products' ).slick( 'refresh' )
			}
		}
	}, [
		infinite
	] )

	const mainClasses = classnames( [
		'czgb-products-carousel-block',
		className,
		enableContainer ? 'container' : '',
	], applyFilters( 'cartzillagb.products-carousel.main-block.classes', {}, props ) )

	const titleComp = showTitle &&
		<RichText
			tagName={ 'h3' }
			value={ title }
			className={ classnames( [
				'czgb-products-carousel__title',
				showHeaderButton ? 'h3 mb-0 pt-3 mr-2' : 'h3 text-center',
			] ) }
			placeholder={ __( 'Title for This Block', i18n ) }
			onChange={ title => setAttributes( { title } ) }
			keepPlaceholderOnFocus
		/>

	const headerButtonComp = showHeaderButton &&
		<ButtonEditHelper
			attrNameTemplate="headerButton%s"
			setAttributes={ setAttributes }
			blockAttributes={ props.attributes }
		/>

	const footerButtonComp = showFooterButton &&
		<ButtonEditHelper
			attrNameTemplate="footerButton%s"
			setAttributes={ setAttributes }
			blockAttributes={ props.attributes }
		/>

	const headerComp = showTitle && showHeaderButton ? (
		<div className="czgb-products-carousel__header d-flex flex-wrap justify-content-between align-items-center pt-1 border-bottom pb-4 mb-4" >
			{ titleComp }
			<div className="pt-3" >
				{ headerButtonComp }
			</div>
		</div>
	) : ( showTitle ? (
		titleComp
	) : ( showHeaderButton ? (
		<div className="czgb-products-carousel__header d-flex flex-wrap justify-content-between align-items-center pt-1 border-bottom pb-4 mb-4" >
			{ headerButtonComp }
		</div>
	) : '' ) )

	const footerComp = showFooterButton && (
		<div className="czgb-products-carousel__footer text-center pt-3" >
			{ footerButtonComp }
		</div>
	)

	const defaultCarouselOptions = applyFilters( 'cartzillagb.products-carousel.main-block.classes', {
		slidesToShow: 5,
		slidesToScroll: 5,
		dots: true,
		arrows: true,
		adaptiveHeight: true,
		prevArrow: '<i class="czi-arrow-left"></i>',
		nextArrow: '<i class="czi-arrow-right"></i>',
		customArrows: '.cz-custom-controls',
		speed: 500,
		autoplay: false,
		autoplaySpeed: 3000,
		pauseOnHover: true,
		responsive: [
			{
				breakpoint: 1198.98,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 991.98,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},
			{
				breakpoint: 575.98,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		],
	}, props )

	let carouselOptions = {
		slidesToShow: getAttrValue( 'slidesToShow', 5 ),
		slidesToScroll: getAttrValue( 'slidesToScroll', 5 ),
		dots: getAttrValue( 'dots' ),
		arrows: getAttrValue( 'arrows' ),
		autoplay: getAttrValue( 'autoplay'),
		autoplaySpeed: getAttrValue( 'autoplaySpeed', 3000 ),
		responsive: [
			{
				breakpoint: 1198.98,
				settings: {
					slidesToShow: getAttrValue( 'slidesToShowLaptop', 4 ),
					slidesToScroll: getAttrValue( 'slidesToScrollLaptop', 4 ),
				}
			},
			{
				breakpoint: 991.98,
				settings: {
					slidesToShow: getAttrValue( 'slidesToShowTablet', 3 ),
					slidesToScroll: getAttrValue( 'slidesToScrollTablet', 3 ),
				}
			},
			{
				breakpoint: 575.98,
				settings: {
					slidesToShow: getAttrValue( 'slidesToShowMobile', 1 ),
					slidesToScroll: getAttrValue( 'slidesToScrollMobile', 1 ),
				}
			}
		],
	}

	const blockAttributes = { ...attributes }

	if( infinite === false ) {
		carouselOptions.infinite = false
	} else {
		delete blockAttributes.infinite
	}

	carouselOptions = { ...defaultCarouselOptions, ...carouselOptions }

	const wraperAttr = {}

	wraperAttr.className = classnames( [
		'cz-carousel',
		arrows && 'cz-controls-outside',
		showHeaderButton ? 'pt-2' : 'pt-4',
	] )

	const setBlockId = blockId => setAttributes({ blockId })

	if ( clientId !== blockId ) {
		setBlockId( clientId )
	}

	return (
		<BlockContainer.Edit className={ mainClasses } blockProps={ { ...props, attributes:{ ...blockAttributes, anchor: blockId !== undefined ? blockId : clientId } } } data-slick-classes="js-slick-carousel" data-slick-attributes={ JSON.stringify( carouselOptions ) } render={ () => (
			<Fragment>
				{ headerComp }
				<div ref={ slickEl } { ...wraperAttr }>
					<div className="cz-custom-controls"></div>
					<InnerBlocks
						template={ [
							[ 'czgb/products', {
								columns: slidesToShow || 5,
								placeholder: slidesToShow || 5,
								limit: 7,
								exclude: [ 'columns' ]
							} ]
						] }
						templateLock="all"
					/>
				</div>
				{ footerComp }
			</Fragment>
		) } />
	)
}

export default compose(
	withUniqueClass,
	withSetAttributeHook,
	withTabbedInspector( [ 'style', 'advanced' ] ),
	withBlockStyles( createStyles, { editorMode: true } ),
	withClickOpenInspector( [
		[ '.czgb-products-carousel__title', 'title' ],
	] ),
	withDispatch( ( dispatch, ownProps, { select } ) => {
		return {
			updateColumns( slidesToShow ) {
				const { clientId } = ownProps
				const { getBlockOrder } = select( 'core/block-editor' )
				const { updateBlockAttributes } = dispatch( 'core/block-editor' )
				const innerBlockIds = getBlockOrder( clientId )

				innerBlockIds.forEach( innerBlockId => {
					updateBlockAttributes( innerBlockId, {
						columns: slidesToShow || 5,
						placeholder: slidesToShow || 5,
					} )
				} )
			}
		}
	} ),
)( edit )